import React from 'react';
import { IReportTemplate, ReportType } from '../../graphql/schema/p4types';
import { useFormContext } from 'react-hook-form';
import Dropdown from '../connectedForm/Dropdown';
import { getDefaultOutputType } from '../../utils/getDefaultOutputType';
import { IDocumentValues, useDocumentCarouselStyles } from './documentCarouselUtil';
import { useReportTemplatesQuery } from '../../utils/hooks';
import Fieldset from '../connectedForm/Fieldset';
import { Switch } from '@fluentui/react-components';
import { findDocumentSource } from './DocumentSource';

const DocumentCarouselTemplate = ({
  reportType,
  singleRecipient,
}: {
  reportType: ReportType;
  singleRecipient: boolean;
}) => {
  const { templates } = useReportTemplatesQuery(reportType);
  const { watch, setValue } = useFormContext<IDocumentValues>();

  const overrideTemplate = watch('overrideTemplate');

  const displayOverride = !singleRecipient;

  const styles = useDocumentCarouselStyles();

  const documentSource = findDocumentSource(reportType);

  return (
    <div className={styles.row}>
      {displayOverride ? (
        <Fieldset cols={1 / 2} style={{ paddingLeft: 0, paddingRight: 0 }}>
          <Switch
            data-testid="document-carousel-override-template"
            className={styles.switch}
            checked={overrideTemplate}
            label={
              overrideTemplate
                ? 'Select a template for this print operation'
                : `${documentSource?.label ?? 'Customer'} default templates will be used`
            }
            onChange={(ev, data) => {
              setValue('overrideTemplate', data.checked ?? false, { shouldTouch: true, shouldDirty: true });
            }}
          />
        </Fieldset>
      ) : null}
      {overrideTemplate ? (
        <Fieldset cols={displayOverride ? 1 / 2 : 1} style={{ paddingLeft: 0, paddingRight: 0 }}>
          <Dropdown
            data-testid="document-carousel-template"
            options={templates}
            valueKey="id"
            labelKey="name"
            onChange={(newTemplate: IReportTemplate) => {
              setValue('template', newTemplate, { shouldTouch: true, shouldDirty: true });
              setValue('outputType', getDefaultOutputType(newTemplate?.reportTemplateFormat).value, {
                shouldTouch: true,
                shouldDirty: true,
              });
            }}
            label={'Template'}
            includeLabel={!displayOverride}
            value={watch('template')}
          />
        </Fieldset>
      ) : null}
    </div>
  );
};

export default DocumentCarouselTemplate;
